import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { TaskStatus } from '@/types/productFeed';
import SubTask from '@/components/SubTask';
import DownloadReportField from '@/components/DownloadReportField';

interface Step3CompletionProps {
  vendor: string;
  onProceedWithCategorization: () => void;
  stepThreeTasks?: TaskStatus;
}

const Step3Completion: React.FC<Step3CompletionProps> = ({
  vendor,
  onProceedWithCategorization,
  stepThreeTasks
}) => {

  const subTasks = stepThreeTasks?.subTasks || []
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Sub Tasks Section */}
      <SubTask subTasks={subTasks} />

      {/* Status Section */}
      <Card className="bg-white border border-gray-200 shadow-sm">
        <CardHeader>
          <CardTitle className="text-lg font-semibold">Status</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          {/* Master Data Processing */}
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-medium">Master Data Processing</h3>
            </div>

            {/* Download Report Button */}
            {/* <DownloadReportField
              status="pending"
              rawProductFeedValidationReportLocation=""
            /> */}

            {/* Proceed with Product Type & Sub Type Categorization Button */}
            <Button
              // disabled={!subTasks?.length || !subTasks.every(task => task?.status === "completed") || stepThreeTasks?.status !== "completed"}
              disabled={!subTasks?.length || !subTasks.every(task => task?.status === "completed")}
              onClick={onProceedWithCategorization}
              className="w-full bg-green-600 hover:bg-green-700 text-white flex items-center justify-center gap-2 disabled:cursor-not-allowed"
            >
              Proceed with Product Type & Sub Type Categorization
              <ArrowRight className="h-4 w-4" />
            </Button>
            <div className="flex justify-between">
              <span className="text-sm text-gray-600">Vendor:</span>
              <Badge className="bg-blue-100 text-blue-700">{vendor}</Badge>
            </div>
            <div className="flex justify-between">
              <span className="text-sm text-gray-600">Status:</span>
              <Badge className="bg-blue-100 text-blue-700">{stepThreeTasks?.status || 'Pending'}</Badge>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Step3Completion; 